
import Vue from 'vue';
import SearchTag from './SearchTag.vue';
import { ITag } from '../store/state';

interface ISearchFiltersComputed {
  tags: ITag[];
}

export default Vue.extend<{}, {}, ISearchFiltersComputed ,{} >({
	name: 'SearchFilters',
	computed: {
    tags() {
      return this.$store.getters.tags;
    }
	},
  components: {
    SearchTag
  }
})
